import NoMatch from 'Route/NoMatch';
import { CmsPage as SourceCmsPage } from 'SourceRoute/CmsPage/CmsPage.component';
import CmsBlock from 'Component/CmsBlock';
import Popup from 'Component/Popup';
import ProductPopup from '@mageguide/better-wishlist/src/component/ProductPopup';
import WishlistPopup from '@mageguide/better-wishlist/src/component/WishlistPopup';
import Loader from 'Component/Loader';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import React, { lazy, Suspense } from "react";
import Html from 'Component/Html';

// Define a mapping object that specifies the alternative characters for each Greek letter
const greekAlternatives = {
    'α': ['ά','α'],
    'ά': ['ά','α'],
    'ε': ['έ','ε'],
    'έ': ['έ','ε'],
    'η':['ι','ή','ί','ϊ','ΐ','η'],
    'ι':['ι','ή','ί','ϊ','ΐ','η'],
    'ή':['ι','ή','ί','ϊ','ΐ','η'],
    'ί':['ι','ή','ί','ϊ','ΐ','η'],
    'ϊ':['ι','ή','ί','ϊ','ΐ','η'],
    'ΐ':['ι','ή','ί','ϊ','ΐ','η'],
    'υ': ['ύ', 'ϋ', 'ΰ', 'υ'],
    'ϋ': ['ύ', 'ϋ', 'ΰ', 'υ'],
    'ΰ': ['ύ', 'ϋ', 'ΰ', 'υ'],
    'ύ': ['ύ', 'ϋ', 'ΰ', 'υ'],
    'ο': ['ό', 'ώ', 'ω', 'ο'],
    'ω': ['ώ', 'ό', 'ο', 'ω'],
    'ό': ['ώ', 'ω', 'ο', 'ό'],
    'ώ': ['ό', 'ω', 'ο', 'ώ']
  };

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

/** @namespace Route/CmsPage/Component */
export class CmsPage extends SourceCmsPage {
    popupRef = () => createRef();

    renderLeftCol() {
        return(
            <div className="CmsPage-LeftBlock">
                <CmsBlock noWrapper="true" identifier={ 'cmspage-left-block' } />
            </div>
        );
    }

  // Define a helper function to create a regular expression that matches a Greek word
    createGreekRegex(word) {
        let regex = '';
        for (let i = 0; i < word.length; i++) {
            const letter = word[i];
            const alternatives = greekAlternatives[letter] || [letter];
            regex += `[${alternatives.join('')}]`;
        }
        return regex;
    }

    onSearch(e) {
        const { handleChange } = this.props;
        handleChange(e)

        const searchCriteria = e.target.value || '';

        const normalizedSearchCriteria = searchCriteria.normalize('NFC');

        const rowContent = document.getElementsByClassName('CmsPage-Faq_accordian_content');

        for (let index = 0; index < rowContent.length; index++) {
          const element = rowContent[index];
          let text = element.innerHTML;
          const [button] = element.parentElement.parentElement.querySelectorAll('[role="button"]');
          const content = element.parentElement;
          let buttonText = button.innerHTML;

          // Normalize text to NFC form to ensure consistent comparison
          text = text.normalize('NFC');
          buttonText = buttonText.normalize('NFC');

          // Remove any existing highlights from previous searches
          text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
          buttonText = buttonText.replace(/(<mark class="highlight">|<\/mark>)/gim, '');

          if (normalizedSearchCriteria !== '') {
            // Create a regular expression that matches the search criteria and its alternative Greek letters
            const regex = new RegExp(`(?![^<>]*>)(${this.createGreekRegex(normalizedSearchCriteria)})(?![^<>]*>)`, 'ig');

            // Highlight all matches in the text
            let newText = text.replace(regex, '<mark class="highlight">$&</mark>');
            let newButtonText = buttonText.replace(regex, '<mark class="highlight">$&</mark>');
            newText.replace(regex, "$1;&nbsp");
            newButtonText.replace(regex, "$1;&nbsp");

            button.innerHTML = newButtonText;
            element.innerHTML = newText;

            // Show or hide the element and its parent element based on whether there is a match or not
            if(regex.test(newText) || regex.test(newButtonText)) {
              element.parentElement.parentElement.style.display = "block";
              if(button) {
                button.classList.add('ExpandableContent-Button_isContentExpanded');
              }
              content.classList.add('ExpandableContent-Content_isContentExpanded');
              element.style.display = "block";
            } else {
              element.parentElement.parentElement.style.display = "none";
              if(button) {
                button.classList.remove('ExpandableContent-Button_isContentExpanded');
              }
              element.parentElement.classList.remove('ExpandableContent-Content_isContentExpanded');
              element.style.display = "none";
            }
          } else {
            // If the search criteria is empty, remove any highlights and show all elements
            const newButtonText = buttonText.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
            const newText = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
            element.innerHTML = newText;
            button.innerHTML = newButtonText;

            if(button) {
                button.classList.remove('ExpandableContent-Button_isContentExpanded');
              }

            element.parentElement.classList.remove('ExpandableContent-Content_isContentExpanded');
            element.parentElement.parentElement.style.display = "block";
            element.style.display = "block";
          }
        }

    }

    renderSearchOptions() {
        const { isLoading, page: { is_search_pwa = false }, searchCriteria } = this.props;

        if(!is_search_pwa) {
            return null;
        }

        return(
            <div
             block="CmsPage"
             elem="SearchInnerWrapper"
            >
            <input
                id="search-field"
                // ref={ this.searchBarRef }
                block="SearchField"
                elem="Input"
                onChange={ (e) => this.onSearch(e) }
                // onKeyDown={ () => this.onSearch(searchCriteria) }
                value={ searchCriteria }
                mods={ { isActive: !isLoading } }
                placeholder={ __('Search') }
                autoComplete="off"
                aria-label={ __('Search') }
            />
                {searchCriteria.length > 0 ?
                    <span onClick={ () => this.onSearch({ target: { value: '' } })} />
                    : null}
        </div>
        )
    }

    renderContent() {
        const {
            isLoading,
            page: { content }
        } = this.props;

        if (isLoading) {
            return (
                <>
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                </>
            );
        }

        if (!isLoading && !content) {
            return null;
        }

        return <Html content={ content } />;
    }

    renderTopSection() {
        const {
            page,
            isPageLoaded
        } = this.props;
        const {content_heading, is_search_pwa = false } = page;

        if(content_heading == '' && !is_search_pwa || !isPageLoaded) {
            return null;
        }

        return(
            <div block="CmsPage" elem="Top" mods={{ noSearch:!is_search_pwa}}>
                { this.renderHeading() }
                { this.renderSearchOptions() }
            </div>
        )
    }

    renderChannelLogo(){
        return (
            <div
                block="CmsPage" elem="Foot_layout3">
                <UniversalIcon
                    src={media('chanel-authorized-retailers-logo-chanelauthorizedlogo.png', WYSIWYG_MEDIA)}
                    alt="CHANEL Reseller icon"
                />
            </div>
        );
    }

    renderDiorReseller() {
        return (
            <div
                block="CmsPage" elem="Foot_diorReseller">
                <UniversalIcon
                    src={media('dior-authorized-retailer-GR.png', WYSIWYG_MEDIA)}
                    alt="Dior Reseller icon"
                />
            </div>
        );
    }

    renderWishlistPopup() {
        const {
            isLoading
        } = this.props;
        return (
            <Popup
                ref={this.popupRef}
                id={"WISHLIST_POPUP"}
                clickOutside={false}
                mix={{ block: 'ProductCartWishlistPopup' }}
            >
                <Suspense fallback={<Loader isLoading />}>
                    <WishlistPopup
                        isProductList
                        {...this.props} />
                </Suspense>
            </Popup>
        )
    }

    renderProductPopup() {
        const {
            isLoading
        } = this.props;

        return (
            <Popup
                ref={this.popupRef}
                id={"PRODUCTLIST_POPUP"}
                clickOutside={false}
                mix={{ block: 'WishlistItem-Edit' }}
            >
                <Suspense fallback={<Loader isLoading />}>
                    <ProductPopup
                        isProductList={true}
                        {...this.props}
                    />
                </Suspense>
            </Popup>
        )
    }

    render() {
        const {
            page: { bg_color },
            page,
            isBreadcrumbsActive,
            isLoading,
            isPageLoaded,
            renderSlider,
            isFindBar
        } = this.props;
        const { page_width, page_layout } = page;
        const style = {
            'background': bg_color ? bg_color : 'none'
        }

        if (!isLoading && !isPageLoaded) {
            return <NoMatch />;
        }

        if (isFindBar()) {
            return (
                <main
                    block="CmsPage"
                    mods={{ isBreadcrumbsHidden: !isBreadcrumbsActive }}
                    style={style}
                >
                    <div block="CmsPage" elem="Wrapper" mods={{ page_width: 'default' }}>
                        <div id="findbar-search-results">
                        </div>
                    </div>
                    {this.renderWishlistPopup()}
                    {this.renderProductPopup()}
                </main >
            );
        }

        if (page_layout === "2columns-left") {
            return (
                <main
                    block="CmsPage"
                    mods={ { isBreadcrumbsHidden: !isBreadcrumbsActive } }
                    style={ style }
                >
                    <div block="CmsPage" elem="Wrapper" mods={ { page_width, page_layout } }>
                        { this.renderTopSection() }
                        <div block="CmsPage" elem="Content">
                            { this.renderLeftCol() }
                            <div className="CmsPage-MainBlock">{ this.renderContent() }</div>
                        </div>
                    </div>
                    <UniversalIcon
                        src={media('cms_page_bkg_image.svg', WYSIWYG_MEDIA)}
                        alt="bkgImage"
                        className="CmsPage-BkgImage"
                    />
                </main>
            );
        }

        return (
            <main
              block="CmsPage"
              mods={ { isBreadcrumbsHidden: !isBreadcrumbsActive } }
              style={ style }
            >
                <div block="CmsPage" elem="Wrapper" mods={ { page_width } }>
                    { this.renderTopSection() }
                    <div block="CmsPage" elem="Content">
                        { renderSlider }
                        { this.renderContent() }
                    </div>
                </div>
                {window.location.pathname.includes('brand/chanel') ? this.renderChannelLogo() : ''}
                {window.location.pathname.includes('brand/dior/') ? this.renderDiorReseller() : ''}
            </main >
        );
    }
}

export default CmsPage;
